import React from "react";
import { useTranslation } from "react-i18next";
import { TeamPrivacyType, TeamPrivacy } from "../../types";

interface PrivacyTypesSectionProps {
  allPrivacyTypes: TeamPrivacyType[];
  enabledPrivacyTypes: TeamPrivacy[];
  saving: boolean;
  saveSuccess: boolean;
  onTogglePrivacyType: (typeId: TeamPrivacy) => void;
}

export const PrivacyTypesSection: React.FC<PrivacyTypesSectionProps> = ({
  allPrivacyTypes,
  enabledPrivacyTypes,
  saving,
  saveSuccess,
  onTogglePrivacyType,
}) => {
  const { t } = useTranslation('adminPage');

  return (
    <div className="setup-section">
      <h2>{t('sections.privacyTypes.title')}</h2>
      <p className="help-text">{t('sections.privacyTypes.description')}</p>

      <div className="status-card">
        <div className="status-content">
          {allPrivacyTypes.length > 0 ? (
            <div className="admin-privacy-container">
              {allPrivacyTypes.map((type) => {
                const isEnabled = enabledPrivacyTypes.includes(type.id);
                const isLastEnabled = enabledPrivacyTypes.length === 1 && isEnabled;

                return (
                  <div
                    key={type.id}
                    className={`admin-privacy-item ${isEnabled ? 'enabled' : 'disabled'}${saving ? ' saving' : ''}`}
                  >
                    <input
                      type="checkbox"
                      id={`privacy-type-${type.id}`}
                      checked={isEnabled}
                      onChange={() => onTogglePrivacyType(type.id)}
                      disabled={saving || isLastEnabled}
                      className="admin-checkbox"
                      title={isLastEnabled ? t('messages.cannotDisableLastPrivacyTypeTooltip') : ""}
                    />
                    <label
                      htmlFor={`privacy-type-${type.id}`}
                      className={`admin-privacy-label-container${saving || isLastEnabled ? ' disabled' : ''}`}
                    >
                      <div className="admin-privacy-icon-row">
                        <span className="admin-privacy-icon">{type.icon}</span>
                        <span className="admin-privacy-name">{t(`messages.privacyNames.${type.id}`, type.label)}</span>
                      </div>
                      <div className="admin-privacy-desc">
                        {t(`messages.privacyDescriptions.${type.id}`, type.description)}
                      </div>
                    </label>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="errors-section">
              <p>⚠️ {t('sections.privacyTypes.loadingTypes')}</p>
            </div>
          )}

          {saveSuccess && (
            <div className="admin-success-msg">
              ✓ {t('sections.privacyTypes.successMessage')}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
